<template>
  <div
    class="group flex w-fit cursor-pointer items-center gap-[6px]"
    @drop.prevent="handleDrop"
    @dragover.prevent=""
  >
    <KeywordListStarBtn :variant :open />
    <KeywordListItem
      v-if="list"
      :amount="list.keywords.length"
      :color="list.color"
      :is-dragging-keyword-in-list="isDraggingKeywordInList"
      :list-name="list.name"
      :loading
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import KeywordListItem from '@/common/components/atoms/KeywordListItem';
import KeywordListStarBtn from '@/common/components/atoms/KeywordListStarBtn';
import { mixPanelEvents } from '@/common/constants';
import { track } from '@/helpers/analytics/mixpanel';

interface Props {
  draggingKeyword?: string | null,
  list?: {
    color: string,
    id: number,
    keywords: {
      id: number,
      keyword: string,
    }[]
    name: string,
  } | null | undefined
  loading?: boolean,
  max: number,
  open?: boolean,
  showSelectedList?: boolean,
  variant?: 'orange' | 'green',
}

const props = withDefaults(defineProps<Props>(), {
  draggingKeyword: null,
  list: null,
  loading: false,
  open: false,
  showSelectedList: false,
  variant: 'green',
});

const emit = defineEmits<{
  onAddKeywordToList: [listId: number, draggingKeyword: string]
}>();

const isMaxKeywords = computed<boolean>(() => props.list.keywords.length >= props.max);
const isDraggingKeywordInList = computed<boolean>(() => props.list.keywords.map((item) => item.keyword).includes(props.draggingKeyword));
const canAddKeywords = computed<boolean>(() => !isMaxKeywords.value && !isDraggingKeywordInList.value);

const handleDrop = () => {
  if (canAddKeywords.value) {
    emit('onAddKeywordToList', props.list.id, window.DRAGGING_KEYWORD);
    track(mixPanelEvents.DRAGGED_KEYWORD_TO_LIST);
  }
};
</script>

<style scoped>
/* Add your styles here */
</style>
